export default __webpack_public_path__ + "static/media/msolution.7e99dc3f.jpg";